import { useQuery } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { GetShareSignatureResponse } from '@/types/clientDetailsApiTypes';
import type { Maybe } from '@/types/common';
import { SHARE_SIGNATURE_QUERY_KEY } from '../../consts/client-detail';

export const useGetShareSignatureQuery = (clientId: Maybe<number | string>) => {
  const { doFetch: getShareSignature } = useFetch<void, GetShareSignatureResponse>();

  return useQuery({
    queryKey: [SHARE_SIGNATURE_QUERY_KEY, clientId],
    queryFn: () =>
      getShareSignature(`/api/clients/${clientId}/update/data/signature`, {
        suppressErrorToast: true,
      }),
    select: (response) => response.data.signature,
    enabled: !!clientId,
    staleTime: 0,
    refetchOnMount: 'always',
  });
};
